import { EMPTY_LIST } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../Button'

export function isTableModalConnectionActionsSelectionEmpty({
  selectAllPages,
  selected,
}) {
  return !selectAllPages && selected.length === 0
}

export function getTableModalConnectionActionsMoreActions({
  ButtonConnect,
  ButtonDisconnect,
  ButtonDisconnectAll,
  buttonConnectProps,
  buttonDisconnectAllProps,
  buttonDisconnectProps,
  isSelectionEmpty,
  t,
}) {
  return [
    ...(ButtonConnect
      ? [
          {
            ...buttonConnectProps,
            Component: Button.Flat,
            height: BUTTON_HEIGHT_40,
            isGrey: true,
            text: t('Modal.ConnectActionKey'),
          },
        ]
      : EMPTY_LIST),
    ...(ButtonDisconnectAll
      ? [
          {
            ...buttonDisconnectAllProps,
            Component: Button.Flat,
            height: BUTTON_HEIGHT_40,
            isGrey: true,
            text: t('Modal.DisconnectAllActionKey'),
          },
        ]
      : EMPTY_LIST),
    ...(ButtonDisconnect
      ? [
          {
            ...buttonDisconnectProps,
            Component: Button.Flat,
            disabled: isSelectionEmpty,
            height: BUTTON_HEIGHT_40,
            isGrey: true,
            text: t('Modal.DisconnectActionKey'),
          },
        ]
      : EMPTY_LIST),
  ]
}
